import { useSelector } from 'react-redux';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import InfrastructureElementTableService from '../service/InfrastructureElementTableService';

const config = data => {
	return {
		key: 'infrastructureElementTable',
		text: 'Infrastructure Element',
		textKey: 'infrastructureElementTable',
		service: InfrastructureElementTableService,
		editFormState: item => `/infrastructure-element/edit/${item ? item.id : 'new'}`,
		toolbarAction: data.user.isSuperAdmin ? ['filter', 'search', 'refresh', 'new'] : ['search', 'refresh', 'new'],
		rowAction: ['modify', 'delete'],
		filterFields: [
			{
				propertyName: 'project',
				text: 'Project',
				propertyType: 'Long',
				type: 'IN',
				visibleIf: () => data.user.isSuperAdmin
			}
		],
		columns: [
			{
				key: 'name',
				text: 'Name',
				textKey: 'name',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'project.name',
				text: 'Project',
				textKey: 'project.name',
				type: 'text',
				sortable: true,
				visibleIf: () => data.user.isSuperAdmin,
				disablePadding: false
			},
			{
				key: 'elementType.name',
				text: 'Element Type',
				textKey: 'elementType',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'coordLat',
				text: 'Latitude',
				textKey: 'coordLat',
				type: 'text',
				sortable: false,
				disablePadding: false
			},
			{
				key: 'coordLng',
				text: 'Longitude',
				textKey: 'coordLng',
				type: 'text',
				sortable: false,
				disablePadding: false
			},
			{
				key: 'locationList',
				text: 'Location',
				textKey: 'locationList',
				type: 'text',
				sortable: false,
				disablePadding: false
			}
		]
	};
};

function InfrastructureElementTable() {
	const user = useSelector(({ auth }) => auth.user);
	const myConfig = config({ user });
	return <TableBrowser config={myConfig} />;
}

export default withReducer('infrastructureElementTable', reducer('infrastructureElementTable'))(InfrastructureElementTable);
